import React, { Component, ReactNode } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import App from './index';
import { Store } from 'redux';
import { History } from 'history';

interface IRootProps {
  store: Store;
  history: History;
}

export default class Root extends Component<IRootProps> {
  public render(): ReactNode {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    );
  }
}
